import api from ".";

export const companyCrud = (data, method, callBack) => {
    const path = data?.id ? `/company/${data.id}/` : '/company/';

    const payload = { ...data };
    if (method !== 'get') {
        delete payload.id;
    }

    const config = method === 'get' && !data?.id ? { params: data } : payload;

    api[method](path, config)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const exportCompany = ({ }, callBack) => {
    api.get(`/companies/download/`, {
        responseType: 'blob',
    })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', `Datara_companies.xlsx`);

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            callBack(response.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};
